/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskMcpServerCount = {
  /**
   * Deduplicated live findings on this server in the window.
   */
  findings: number;
  /**
   * Concrete MCP server ID.
   */
  mcpServerId: string;
};

/** @internal */
export const RiskMcpServerCount$inboundSchema: z.ZodMiniType<
  RiskMcpServerCount,
  unknown
> = z.pipe(
  z.object({
    findings: z.int(),
    mcp_server_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_server_id": "mcpServerId",
    });
  }),
);

export function riskMcpServerCountFromJSON(
  jsonString: string,
): SafeParseResult<RiskMcpServerCount, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskMcpServerCount$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskMcpServerCount' from JSON`,
  );
}
